import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Chip
} from '@mui/material';
import {
    Assessment as AssessmentIcon
} from '@mui/icons-material';

const AnalyticsDashboard = () => {
    return (
        <Box sx={{ p: 3 }}>
            <Paper sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
                <AssessmentIcon sx={{ fontSize: 80, color: '#4caf50', mb: 2 }} />
                <Typography variant="h4" sx={{ fontWeight: 700, mb: 2, color: '#1a237e' }}>
                    Analytics & Reports
                </Typography>
                <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
                    Detailed analytics and insights for talent development
                </Typography>
                <Chip label="Coming Soon" color="primary" />
            </Paper>
        </Box>
    );
};

export default AnalyticsDashboard;
